import React, { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { slotsCasinoRoute } from 'shared/constants/routes/slotsRoutes'

import { selectBackUrl } from 'features/slots/selectors'

const RouteReplacingSlots = () => {
  const history = useHistory<any>()
  const backUrl = useSelector(selectBackUrl, shallowEqual)

  useEffect(() => {
    history.replace(history.location.state?.prevPath || backUrl || slotsCasinoRoute)
  }, [])

  return null
}

export default RouteReplacingSlots
